import "./files-uploader.styl"
import filesUploaderTemplateFn from "./files-uploader.pug"
import ko from "knockout"

### Auth, Real-Time & Stores ###
import { AttachmentStore } from "@/stores/attachment-store.core"

### Modals ###
import { modalManager } from "@/lib/managers/modal-manager"
import { Modal } from "@/lib/components/modals/modal"
import { FileDownloadPaneViewModel } from "@/lib/components/modals/file-download-pane"
import { ConfirmActionPaneViewModel } from "@/lib/components/modals/confirm-action-pane"

### Models ###
import { Attachment } from "@/models/attachment"

export class FilesUploader
   constructor: (params) ->
      assertArgs(arguments, Object)
      assertOfType(params.files, [arrayOf(Attachment), Function])
      assertOfType(params.uploadCallback, optional(Function))
      assertOfType(params.deleteCallback, optional(Function))
      assertOfType(params.allowUploadPerm, optional(Boolean))
      assertOfType(params.requireTwoStep, optional(Boolean))
      assertOfType(params.isUploading, optional(Function))
      @allowUploadPerm = if params.allowUploadPerm? then params.allowUploadPerm else true
      if params.files instanceof Function
         assertOfType(params.files(), arrayOf(Attachment))
         @files = params.files
      else
         @files = ko.observableArray(params.files)

      @uploadCallback = params.uploadCallback
      @deleteCallback = params.deleteCallback
      @requireTwoStep = params.requireTwoStep or false
      @isUploading = if params.isUploading? then params.isUploading else ko.observable(false)
      @isUploading(false)

   # Used in files-uploader.pug
   handleNewFile: (err, file) =>
      return unless @allowUploadPerm
      filetype = if file.type.length != 0 then file.type else null
      tmpAttachment = new Attachment({
         name: file.name,
         mimetype: filetype
         }, true)
      @isUploading(true)
      data = {name: file.name, mimetype: filetype, bytes: file.size}

      try
         response = await AttachmentStore.createAttachment(data).payload
         attachment = response.data
         tmpAttachment.id = attachment.id
         formData = new FormData()
         formData.append("upload", file)

         success = await AttachmentStore.uploadFile(tmpAttachment.id, formData).payload
         return @isUploading(false) unless success
         tmpAttachment.createdAt(attachment.created_at)
         @files.push(tmpAttachment)
         @isUploading(false)
         @uploadCallback?(null, attachment.id)
      catch err
         @isUploading(false)
         console.log "error: ", err

   # Used in files-uploader.pug
   deleteFile: (data) =>
      execute = =>
         try
            success = await AttachmentStore.deleteAttachment(data.id).payload
            return unless success
            @files.remove(data)
            @deleteCallback?(null, data.id)
         catch err
            if @deleteCallback?
               return @deleteCallback(err)
            console.log "error: ", err
      if @requireTwoStep
         pane1 = new ConfirmActionPaneViewModel("Remove File", null, "Confirm Deletion")
         modal = new Modal()
         modal.setPanes([pane1])
         modalManager.maybeCancelModal ->
            modalManager.showModal modal, null, {class: 'confirm-action-modal'}, (modal, exitStatus) =>
               return unless exitStatus == "finished"
               execute()
      else
         execute()

   # Used in files-uploader.pug
   showDowloadModal: (attachment) =>
      return unless attachment.createdAt()?
      pane1 = new FileDownloadPaneViewModel(attachment)
      modal = new Modal()
      modal.setPanes([pane1])
      modalManager.maybeCancelModal ->
         modalManager.showModal modal, null, {class:"file-download-pane"}

filesUploaderTemplate = filesUploaderTemplateFn()

ko.components.register("files-uploader",
   viewModel: FilesUploader,
   template: filesUploaderTemplate,
)
